import { useState } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { DialogContent } from '../../../components/Dialog/DialogUiRedesign/DialogContent';
import { Loader } from '../../../components/Loader/Loader';
import { CURRENT_PAYMENTS_PROJECT_URL } from '../../../config/constants';
import { useResize } from '../../../hooks/iframe-helpers';
import { formatURL } from '../../../utils/formatURL';
import type { ShipCardParams } from '../ExternalPayments';

import styles from './ExternalPayments.module.scss';
import { useIFrameParams } from './useIFrameParams';
import { useMessagesListener } from './useMessagesListener';

export const ExternalPaymentsV5 = observer(function ExternalPaymentsV5(props: {
  storeType: 'store' | 'mini-store' | 'subscription';
  isDeposit?: boolean;
  shipping?: ShipCardParams;
}) {
  const { iframeRef } = useResize();

  const [iframeStyle, setIframeStyle] = useState<{ height?: number | string; background?: string }>();
  const [iframeLoading, setIframeLoading] = useState(true);
  const [isBottomSheet, setIsBottomSheet] = useState(!!props.isDeposit);

  const externalPaymentUrl = CURRENT_PAYMENTS_PROJECT_URL;
  const iframeParams = useIFrameParams(props);

  useMessagesListener(setIframeStyle, setIframeLoading, props.storeType === 'mini-store', setIsBottomSheet);

  if (!iframeParams) {
    return <Loader />;
  }

  return (
    <>
      <iframe
        ref={iframeRef}
        allow="payment; camera"
        className={classNames(styles.iframe, { [styles.iframeSheet]: isBottomSheet })}
        data-loading={iframeLoading}
        data-testid="payments-iframe"
        sandbox="allow-modals allow-scripts allow-forms allow-same-origin allow-top-navigation allow-popups allow-popups-to-escape-sandbox"
        src={`${formatURL(externalPaymentUrl)}?${iframeParams}`}
        style={isBottomSheet ? { ...iframeStyle, height: undefined } : iframeStyle}
      />
      {iframeLoading && (
        <DialogContent className={styles.loaderWrapper}>
          <Loader customClassName={styles.loader} />
        </DialogContent>
      )}
    </>
  );
});
